module.exports = new __parcel__URL__("saved_souls_level_2.59f0b7bf.png").toString();